import React,{ useEffect } from "react";
import { areas } from "../../helpers/areas";
import { useSelector, useDispatch } from "react-redux";
import { Tarjeta } from "./Tarjeta";
import {
  Grid,
  Avatar,
  Tooltip,
  Card,
  CardActionArea,
  CardContent,
  Typography,
} from "@material-ui/core";
import { Droppable, DragDropContext } from "react-beautiful-dnd";
import {
  documentacionAfiliadoUpdate,
  documentacionAfiliadoDelete,
  documentacionStageAfiliadoDelete,
  documentacionStageAfiliadoUpdate,
} from "../../actions/documentaciones/documentacion";
import { makeStyles, withStyles } from "@material-ui/core/styles";

import { red } from "@material-ui/core/colors";
import DeleteSweepIcon from "@material-ui/icons/DeleteSweep";
import AlertDialogSlide from "../ui/AlertaConfirm";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  title: {
    fontSize: 10,
    marginLeft: 10,
  },
  iconoTrash: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    color: "#fff",
    backgroundColor: red[500],
  },
  contenedorTrash: {
    marginTop: 15,
    marginBottom: 15,
    display: "flex",
    justifyContent: "center",
  },
  gridNone:{
    pointerEvents: 'none',
    opacity: 0.4,
  }
}));
export const ListaDocumentacion = ({idListValido,idListaDoc,idListFami,setHabilitado,idForm,fromBandeja},ref) =>  {
  const classes = useStyles();
  const dispatch = useDispatch();
  let listaTipoDocumentacionParentesco = [];
  let listaTipoDocumentacionTipoAfiliacion = [];
  const baseUrl = process.env.REACT_APP_URL;
  const afiliacion = useSelector((state) => state.afiliacion);
  const {afiliadoEncontrado} = useSelector((state) => state.preinscripto);
  const {familiarSeleccionado} = useSelector((state) => state.familiarSeleccionado);
  const {stateProvisorio } = useSelector((state) => state.stateProvisorio);
  const { idArea: idAreaUsuario } = useSelector((state) => state.auth.areas[0]);

  const { cargada: listaDocuXParentescoCargada, items } = useSelector(
    (state) => state.tipoDocumentacionParentesco
  );
  let listaDocuXParent = items;
  if (listaDocuXParentescoCargada) {
    //si esta seleccionado un afiliado (parseo y filtro)
    if (afiliacion.seleccionado) {
      listaDocuXParent = listaDocuXParent.filter(
        (item) => item.idParentesco === afiliacion.afiliado.id_parentesco
      );
    }
    if (Object.keys(familiarSeleccionado).length>0) {
      listaDocuXParent = listaDocuXParent.filter(
        (item) => item.idParentesco === familiarSeleccionado.id_parentesco
      );
    }/* else{
      listaDocuXParent=[]         //PATRICIO
    } */
    if(Object.keys(afiliacion.consultaAfiliado).length>0){
      listaDocuXParent = listaDocuXParent.filter(
        (item) => item.idParentesco === afiliacion.consultaAfiliado.id_parentesco
      );
    }/* else {
      listaDocuXParent=[]         //PATRICIO
    } */
    listaTipoDocumentacionParentesco = listaDocuXParent.map((item) => {
      return item.tipoDocumentaciones;
    });
  }

  // console.log("Lista docXparentesco: ",listaDocuXParent);
  const {
    cargada: listaDocuXTipoAfiliacionCargada,
    items: items2,
  } = useSelector((state) => state.tipoDocumentacionTipoAfiliacion);
  let listaDocuXTipoAfiliacion = items2;

  if (listaDocuXTipoAfiliacionCargada && idListaDoc!=='idListDocPreinscripto') {
    //si esta seleccionado un afiliado (parseo y filtro)
    if (afiliacion.seleccionado) {
      listaDocuXTipoAfiliacion = listaDocuXTipoAfiliacion.filter(
        (item2) =>
          parseInt(item2.idTipoAfiliacion) ===
          parseInt(afiliacion.afiliado.id_tipo_afiliacion)
      );
    }
    //Extraigo Objetos tipo docu del arreglo
    listaTipoDocumentacionTipoAfiliacion = listaDocuXTipoAfiliacion.map(
      (item) => {
        return item.tipoDocumentaciones;
      }
    );
  }
  if (listaDocuXTipoAfiliacionCargada && idListaDoc==='idListDocPreinscripto') {    
    if (afiliadoEncontrado  && idListFami!=="idListFami") {
      listaDocuXTipoAfiliacion= listaDocuXTipoAfiliacion.filter(
        (item2) =>
          parseInt(item2.idTipoAfiliacion) ===
          parseInt(afiliadoEncontrado.id_tipo_afiliacion)
      );
      // console.log('listaAFiltered',listaDocuXTipoAfiliacion)
    } listaTipoDocumentacionTipoAfiliacion = listaDocuXTipoAfiliacion.map(
      (item) => {
        return item.tipoDocumentaciones;
      }
    );
  }

  if (listaDocuXTipoAfiliacionCargada && idForm==='formConsulta') {    
    if (Object.keys(afiliacion.consultaAfiliado).length>0) {
      listaDocuXTipoAfiliacion= listaDocuXTipoAfiliacion.filter(
        (item2) =>
          parseInt(item2.idTipoAfiliacion) ===
          parseInt(afiliacion.consultaAfiliado.id_tipo_afiliacion)
      );
    } listaTipoDocumentacionTipoAfiliacion = listaDocuXTipoAfiliacion.map(
      (item) => {
        return item.tipoDocumentaciones;
      }
    );
  }

  const arrayTemp = 
    (afiliacion.afiliado?.id_parentesco === 0 || afiliacion.consultaAfiliado?.id_parentesco === 0 || afiliadoEncontrado)
    ? listaTipoDocumentacionTipoAfiliacion
    : listaTipoDocumentacionParentesco
  ;
  //saco si hay duplis
  // const arrayDocumentacion = arrayMixed.filter(      //PATRICIO
  const arrayDocumentacion = arrayTemp.filter(
    (docu, index, self) =>
      index ===
      self.findIndex(
        (t) => t.idTipoDocumentaciones === docu.idTipoDocumentaciones
      )
  );
  const documentacionAfiliado = useSelector(
    (state) => state.documentacionAfiliacion
  );

  useEffect(() => {
    if(idListValido==='idListValido'){
      if(stateProvisorio===true){
        setHabilitado(false)
      }else{
        if(idAreaUsuario === areas.Nacional){
          setHabilitado(false)
        }else{
          setHabilitado(true)
        }
      }
    }
  }, [documentacionAfiliado.items,setHabilitado,stateProvisorio,idListValido,idAreaUsuario])

   let documentacionAfiliadoArray = documentacionAfiliado.items;
   let arrayURLs = [];

  if (documentacionAfiliado.cargada) {
    
    for (var j = 0; j < arrayDocumentacion.length; j++) {
      for (var i = 0; i < documentacionAfiliadoArray.length; i++) {
        if (
          arrayDocumentacion[j].idTipoDocumentaciones ===
          documentacionAfiliadoArray[i].idTipoDocumentaciones
        ) {
          let obj = {};
          obj.url =
            baseUrl + '/'+
            documentacionAfiliadoArray[i].urlCarpeta +
            documentacionAfiliadoArray[i].nombreDocumento;
          obj.id =
            documentacionAfiliadoArray[i].idDocumentacionAfiliado;
          arrayURLs.push(obj);
        }
      }
      arrayDocumentacion[j].URLs = arrayURLs;
      arrayURLs = [];
    }

  }else{
    arrayURLs = [];
    arrayDocumentacion.forEach(url => {
      url.URLs=[]
    });
    documentacionAfiliadoArray=[];
  }

  const [open, setOpen] = React.useState(false);
  const [idDocumentacionAfiliadoSelec, setIdDocumentacionAfiliadoSelec] = React.useState(0)

  const handleDecision =(dec)=>{
    if(dec==='SI'){
      if(idListaDoc==="idListDocPreinscripto"){
        dispatch(documentacionStageAfiliadoDelete(parseInt(idDocumentacionAfiliadoSelec)));  
      }else{
        dispatch(documentacionAfiliadoDelete(parseInt(idDocumentacionAfiliadoSelec)));
      }
    }
    setOpen(false);
  }
  const handleOnDragEnd = (result) => {
    const { destination } = result;

    if (!destination) {
      return;
    }
    const idDocumentacionAfiliado = parseInt(
      result.draggableId.replace("documentacion", "")
    );
    if (destination.droppableId === "eliminardoc") {
      //
      setIdDocumentacionAfiliadoSelec(idDocumentacionAfiliado);
      setOpen(true);

    } else {
      const idTipoDocumentacion = parseInt(
        destination.droppableId
          .replace("idTipoDocumentaciones", "")
          .replace("docu", "")
      );
      if(idListaDoc==="idListDocPreinscripto"){
        dispatch(
          documentacionStageAfiliadoUpdate(
            idDocumentacionAfiliado,
            idTipoDocumentacion
          )
        );
      }else{
        dispatch(
          documentacionAfiliadoUpdate(
            idDocumentacionAfiliado,
            idTipoDocumentacion
          )
        );
      }
    }
   
  };
  return (
    <>
    <AlertDialogSlide open={open} setOpen={setOpen} handleDecision={handleDecision} mensaje="Esta seguro de eliminar la imagen?" />
      <DragDropContext onDragEnd={handleOnDragEnd}>
        <Grid
          container
          spacing={3}
          direction="row"
          justify="flex-start"
          alignItems="center"
          // className={idForm==='formConsulta'?classes.gridNone:null}
        >
          {arrayDocumentacion.map((item, index) => (
            <Droppable
              key={item.idTipoDocumentaciones}
              droppableId={`idTipoDocumentaciones${item.idTipoDocumentaciones}`}
            >
              {(provided) => (
                <Grid
                  key={item.idTipoDocumentaciones}
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  item
                >
                  <Tarjeta
                  
                    {...item}
                    disableButtonAdd={(fromBandeja && idAreaUsuario === areas.Nacional) || (idForm==='formConsulta')}
                    key={item.idTipoDocumentaciones}
                    titulo={`${item.descripcionDocumentacion}`}
                    idTipDoc={item.idTipoDocumentaciones}
                    urls={item.URLs}
                  />
                  {provided.placeholder}
                </Grid>
              )}
            </Droppable>
          ))}
          {(fromBandeja && idAreaUsuario === areas.Nacional) || (idForm==='formConsulta')
            ?
              null
            :
              <Droppable droppableId="eliminardoc">
                {(provided) => (
                  <Card className={classes.cardStyle}>
                    <CardActionArea>
                      <CardContent>
                        <Grid item>
                        <Typography
                            className={classes.title}
                            color="textSecondary"
                            gutterBottom
                          >
                            Arrastre aqui para eliminar
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          key="trashDoc"
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          className={classes.contenedorTrash}
                        >
                          <HtmlTooltip
                            title={
                              <>
                                <em>
                                  {"Eliminar"}
                                  <b>{" imagen"}</b>
                                </em>
                                <br></br>
                                {"Arrastre "} <u>{"aqui"}</u> {" para eliminar"}
                              </>
                            }
                          >
                            <Avatar className={classes.iconoTrash}>
                              <DeleteSweepIcon />
                            </Avatar>
                          </HtmlTooltip>
                          {provided.placeholder}
                        </Grid>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                )}
              </Droppable>
          }
        </Grid>
      </DragDropContext>
    </>
  );
};
